import React, { useState } from "react";
import { Sparkles, Phone, Zap } from "lucide-react";
import MatrixPopup from "./MatrixPopup";

const HeroSection = () => {
  const [showMatrixPopup, setShowMatrixPopup] = useState(false);

  const scrollToContact = () => {
    const element = document.getElementById('contacto');
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleMatrixClick = () => {
    console.log("Matrix button clicked in hero section");
    setShowMatrixPopup(true);
  };

  const handleCloseMatrixPopup = () => {
    setShowMatrixPopup(false);
  };

  return (
    <>
      <section 
        id="inicio" 
        className="relative min-h-screen flex items-center justify-center overflow-hidden"
        style={{
          background: `linear-gradient(rgba(247, 245, 242, 0.9), rgba(247, 245, 242, 0.8)), url('https://images.unsplash.com/photo-1731336479432-3eb5fdb3ab1c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxzcGElMjBsdXh1cnl8ZW58MHx8fHwxNzU3MzU0ODg2fDA&ixlib=rb-4.1.0&q=85')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed'
        }}
      >
        {/* Decorative elements */}
        <div className="absolute top-20 left-10 w-20 h-20 bg-gold-warm/20 rounded-full blur-xl"></div>
        <div className="absolute bottom-20 right-10 w-32 h-32 bg-aqua-soft/20 rounded-full blur-xl"></div>
        
        <div className="relative z-10 text-center px-4 max-w-4xl mx-auto pt-24">
          <div className="mb-6 flex justify-center">
            <div className="bg-white/80 backdrop-blur-sm rounded-full p-4 shadow-lg">
              <Sparkles className="w-12 h-12 text-gold-warm" />
            </div>
          </div>
          
          <h1 className="text-5xl md:text-7xl font-playfair font-bold text-sage-dark mb-6 leading-tight">
            Fonte de Juvence
          </h1>
          
          <p className="text-xl md:text-2xl text-sage-medium mb-4 font-light">
            A sua fonte de beleza e rejuvenescimento
          </p>
          
          <p className="text-lg text-sage-medium mb-8 max-w-2xl mx-auto leading-relaxed">
            Descubra um mundo de bem-estar e sofisticação no coração de Braga. 
            Experimente tratamentos exclusivos numa atmosfera de puro relaxamento.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-6">
            <button 
              onClick={scrollToContact}
              className="bg-gold-warm text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-gold-deep transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
            >
              Contactar
            </button>
            
            <a 
              href="tel:253279717"
              className="flex items-center space-x-2 bg-white/90 backdrop-blur-sm text-sage-dark px-6 py-4 rounded-full hover:bg-white transition-all duration-300 shadow-lg hover:shadow-xl"
            >
              <Phone className="w-5 h-5" />
              <span className="font-semibold">253 279 717</span>
            </a>
          </div>

          {/* Matrix Promotion Button */}
          <div className="mb-8">
            <button
              onClick={handleMatrixClick}
              className="bg-gradient-to-r from-purple-600 to-purple-800 text-white px-8 py-4 rounded-full text-lg font-semibold hover:from-purple-700 hover:to-purple-900 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl flex items-center space-x-2 mx-auto"
            >
              <Zap className="w-6 h-6" />
              <span>Conhecer Matrix Chronology</span>
            </button>
            <p className="text-sm text-sage-medium mt-2 opacity-80">
              ✨ Protocolo exclusivo de rejuvenescimento
            </p>
          </div>
          
          <div className="text-sage-medium">
            <p className="text-sm mb-2">★★★★★</p>
            <p className="text-sm opacity-80">4,925 avaliações excelentes</p>
          </div>
        </div>
        
        {/* Bottom gradient */}
        <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-cream-light to-transparent"></div>
      </section>

      {/* Manual Matrix Popup */}
      {showMatrixPopup && (
        <MatrixPopup 
          showManually={true} 
          onClose={handleCloseMatrixPopup} 
        />
      )}
    </>
  );
};

export default HeroSection;